import { useMutation, useQueryClient } from "@tanstack/react-query";
import { alertasApi } from "../api/alertasApi";

const ALERTAS_KEY = ["alertas"];

// Marcar como lido atualiza o sino na hora (otimista) e troca o cache pela lista que o
// servidor devolve; se a chamada falhar, volta ao estado anterior. A Visão Geral também
// mostra o estado de leitura nos alertas, por isso o "dashboard" é invalidado.
function useAlertReadMutation(mutationFn, applyOptimistic) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onMutate: async (variables) => {
      await queryClient.cancelQueries({ queryKey: ALERTAS_KEY });
      const previous = queryClient.getQueryData(ALERTAS_KEY);
      if (previous) queryClient.setQueryData(ALERTAS_KEY, applyOptimistic(previous, variables));
      return { previous };
    },
    onError: (_error, _variables, context) => {
      if (context?.previous) queryClient.setQueryData(ALERTAS_KEY, context.previous);
    },
    onSuccess: (alertas) => queryClient.setQueryData(ALERTAS_KEY, alertas),
    onSettled: () => queryClient.invalidateQueries({ queryKey: ["dashboard"] }),
  });
}

const setRead = (alertas, id, read) => alertas.map((a) => (a.id === id ? { ...a, read } : a));

export function useMarkAlertReadMutation() {
  return useAlertReadMutation(alertasApi.markRead, (alertas, id) => setRead(alertas, id, true));
}

export function useMarkAlertUnreadMutation() {
  return useAlertReadMutation(alertasApi.markUnread, (alertas, id) => setRead(alertas, id, false));
}

export function useMarkAllAlertsReadMutation() {
  return useAlertReadMutation(alertasApi.markAllRead, (alertas) => alertas.map((a) => ({ ...a, read: true })));
}
